import { Button } from "@/frontend/components/ui/button";
import { PENDING_ACTION_TTL_MS } from "@/shared/pending-action";
import { useChatStore, type ChatMessage } from "../stores/chatStore";
import { useOrgStore } from "../stores/orgStore";

/** Confirm or cancel the send or delete Que proposed in its latest reply. */
export function PendingActionCard({ message }: { message: ChatMessage }) {
  // The latest reply, not the latest message, so a confirm whose request failed can be tried again
  const isLatest = useChatStore((state) => state.messages.filter((m) => m.role === "assistant").at(-1)?.id === message.id);
  const streaming = useChatStore((state) => state.streaming);
  const sendMessage = useChatStore((state) => state.sendMessage);
  const orgId = useOrgStore((state) => state.currentOrgId);
  const action = message.metadata?.pendingAction;

  if (!action || action.status !== "pending" || !isLatest || !orgId) return null;
  if (Date.now() - new Date(action.createdAt).getTime() > PENDING_ACTION_TTL_MS) return null;

  const answer = (confirm: boolean) =>
    sendMessage(orgId, message.conversationId, confirm ? "Yes, go ahead" : "Cancel", true, confirm);

  return (
    <div className="not-prose mt-2 rounded-lg border bg-muted/40 p-3 text-sm">
      <p className="font-medium text-foreground">{action.title}</p>
      <dl className="mt-2 space-y-1">
        {action.details.map(([key, value]) => (
          <div key={key} className="flex gap-2">
            <dt className="shrink-0 text-muted-foreground">{key}</dt>
            <dd className="min-w-0 break-words whitespace-pre-wrap text-foreground">{value}</dd>
          </div>
        ))}
      </dl>
      <div className="mt-3 flex gap-2">
        <Button size="sm" disabled={streaming} onClick={() => answer(true)}>Confirm</Button>
        <Button size="sm" variant="outline" disabled={streaming} onClick={() => answer(false)}>Cancel</Button>
      </div>
    </div>
  );
}
